
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(102|191|788|87)|3(294|74|918|942)|(641|704|73)2|1680|1733|2019|2167|4068|4931|5206|5576|9707)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
